import { ReactNode } from 'react';
import AppHeader from '@/components/Elements/Header/AppHeader';

interface Props {
  children: ReactNode;
  title?: string;
  backButton?: boolean;
  handleBack?: () => void;
}

function Layout({ children, title, backButton = false, handleBack }: Props) {
  return (
    <>
      <AppHeader title={title} showBackButton={backButton} handleBack={handleBack} />
      {children}
    </>
  );
}

export default Layout;
